import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M3.98462 0.833702C4.39883 0.833702 4.73462 1.16949 4.73462 1.5837V2.1152H7.24988V1.5837C7.24988 1.16949 7.58567 0.833702 7.99988 0.833702C8.4141 0.833702 8.74988 1.16949 8.74988 1.5837V2.1152H11.2657V1.5837C11.2657 1.16949 11.6015 0.833702 12.0157 0.833702C12.4299 0.833702 12.7657 1.16949 12.7657 1.5837V2.22655C13.7851 2.54202 14.5256 3.49213 14.5256 4.6152V12.667C14.5256 14.0477 13.4063 15.167 12.0256 15.167H3.97388C2.59316 15.167 1.47388 14.0477 1.47388 12.667V4.6152C1.47388 3.49184 2.2148 2.54153 3.23462 2.2263V1.5837C3.23462 1.16949 3.57041 0.833702 3.98462 0.833702ZM2.97388 6.98125V12.167C2.97388 12.9954 3.64545 13.667 4.47388 13.667H11.5256C12.3541 13.667 13.0256 12.9954 13.0256 12.167V6.98125H2.97388Z';
const draw24px =
  'M18.75,3.35V2a.75.75,0,0,0-1.5,0V3.25h-4.5V2a.75.75,0,0,0-1.5,0V3.25H6.75V2a.75.75,0,0,0-1.5,0V3.34A3.75,3.75,0,0,0,2.31,7V19a3.75,3.75,0,0,0,3.75,3.75H17.93A3.75,3.75,0,0,0,21.68,19V7A3.73,3.73,0,0,0,18.75,3.35ZM20.18,19a2.25,2.25,0,0,1-2.25,2.25H6.06A2.25,2.25,0,0,1,3.81,19V9.72H20.18Z';
const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const CalendarFilledIcon = forwardRef<
  SVGSVGElement,
  ComponentProps<typeof Icon>
>(generateRenderedIcon(icons, 'calendarFilled')) as IconWithRender;

CalendarFilledIcon.displayName = 'CalendarFilledIcon';
CalendarFilledIcon.propTypes = Icon.propTypes;
CalendarFilledIcon.renderIcon = (props) => <CalendarFilledIcon {...props} />;
export default CalendarFilledIcon;
